import { apiClient, ApiResponse } from './apiClient';

export interface RatingData {
  appointmentId: string;
  rating: number;
  comment?: string;
  punctualityRating?: number;
  clarityRating?: number;
  careRating?: number;
  prudenceRating?: number;
  cordialityRating?: number;
  wouldRecommend?: boolean;
  resolvedProblem?: boolean;
}

export interface PendingRating {
  id: string;
  patientId: string;
  doctorId: string;
  appointmentDate: string;
  reason: string;
  doctor?: {
    id: string;
    user: { name: string };
    specialty: string;
  };
  patient?: {
    id: string;
    name: string;
  };
}

export const ratingsService = {
  /**
   * Envia uma nova avaliação
   */
  submitRating: async (data: RatingData): Promise<ApiResponse<any>> => {
    return apiClient.post('/ratings', data);
  },

  /**
   * Busca avaliações pendentes para o usuário atual
   */
  getPendingRatings: async (): Promise<ApiResponse<PendingRating[]>> => {
    return apiClient.get('/ratings/pending');
  },
};
